import {athubAxios} from '../../util'
import {ATHUB_CLOUD_SERVER} from '../server'
import {AuthInfo} from '@/util/user/authInfo';
import _ from 'lodash'
import {addParamsToUrl} from "../../util/common";

const AthubCloudApi = {

    fetchDeptListByAuthSites() {
        let url = `${ATHUB_CLOUD_SERVER}/sys/room/getDeptListByAuthSites.sp`;
        let params = {
            orgid: AuthInfo.details.authorg,
            sites: localStorage.getItem("authsites"),
        }
        let promise = new Promise((resolve, reject) => {

            athubAxios.postByForm(url, params).then(responseBody => {
                if (responseBody.status == 200 && responseBody.data.result == 'OK') {
                    resolve(responseBody.data.deptList);
                } else {
                    reject(responseBody.data.message);
                }
            });
        });
        return promise;
    },

    //获取部门列表(部门下若有数据中心状态为RUNNING则列出)
    fetchRunningDeptList() {
        return new Promise(function (resolve, reject) {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/sys/room/getRunningDeptListByAuthSites.sp`, {
                appId: 'WEB',
                token: localStorage.getItem('token'),
                orgid: localStorage.getItem('authorg') || 'ATHUB'
            }).then(function(res) {
                if (res.data.result === 'OK') {
                    resolve(res.data.deptList);
                } else {
                    reject(res.data.message);
                }
            });
        });
    },

    // 根据部门编号集合查询数据中心
    getRoomsByDeptIds(deptIds) {
      return new Promise((resolve, reject) => {
          athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/sys/room/getRoomsByDepts.sp`, {
              deptIds: deptIds.join(',')
          }).then((res) => {
              if (res.data.result === 'OK') {
                  resolve(res.data.roomList);
              } else {
                  reject('获取数据中心信息失败');
              }
          }, (error) => {
              reject(error);
          });
      });
    },

    // 获取位置信息  作业内容巡检路线选择房间
    getLocations() {
        return new Promise((resolve, reject) => {
            athubAxios.get(`${ATHUB_CLOUD_SERVER}/api/sys/locations.sp`).then((res) => {
                if (res.data.code === 'OK') {
                    resolve(res.data.data);
                } else {
                    reject('获取房间信息失败');
                }
            }, (error) => {
                reject(error);
            });
        });
    },

    //获取当前人所有权限的任务列表
    fetchCurrentTaskIds(app) {
        return new Promise(function (resolve, reject) {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/workflow/fetchCurrentTaskIds/${app}.sp`).then((res) => {
                if (res.data.code === 'OK') {
                    resolve(res.data.data);
                } else {
                    reject("任务列表获取失败！" + res.data.msg);
                }
            });
        });
    },

    getRoomsByAuthSites() {
        return new Promise((resolve, reject) => {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/sys/room/getSysRoomList.sp`, {
                appId: 'WEB',
                token: localStorage.getItem('token'),
            }).then((res) => {
                if (res.data != null) {
                    resolve(res.data);
                } else {
                    reject('获取数据中心失败');
                }
            }, (error) => {
                reject(error);
            });
        });
    },

    getAllRooms() {
        return new Promise((resolve, reject) => {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/sys/room/getSysRoomList.sp`, {
                appId: 'WEB',
                token: localStorage.getItem('token'),
                flag: "all",
            }).then((res) => {
                if (res.data != null) {
                    resolve(res.data);
                } else {
                    reject('获取数据中心失败');
                }
            }, (error) => {
                reject(error);
            });
        });
    },

    getUsersByRoomId(roomId) {
        return new Promise((resolve, reject) => {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/sys/room/getSysuserList.sp`, {
                appId: 'WEB',
                token: localStorage.getItem('token'),
                dcnum: roomId,
            }).then((res) => {
                if (res.data != null) {
                    resolve(res.data);
                } else {
                    reject('获取数据中心用户失败');
                }
            }, (error) => {
                reject(error);
            });
        });
    },

    fetchDeptPostList() {
      return new Promise((resolve, reject) => {
          athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/api/sys/fetchDeptpostList.sp`).then((res) => {
              if (res.data != null) {
                  resolve(res.data);
              } else {
                  reject('获取职位信息失败');
              }
          }, (error) => {
              reject(error);
          });
      });
    },

    //获取所有数据中心列表
    fetchAllSysroomList(){
        return new Promise(function (resolve, reject) {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/sys/room/getSysRoomList.sp`, {
                appId: 'WEB',
                token: localStorage.getItem('token'),
                flag: 'all',
            }).then((res) => {
                resolve(res.data);
            }, (error) => {
                reject(error);
            });
        });
    },

    //获取所有部门
    fetchSysDeptAllList() {
        return new Promise(function (resolve, reject) {
            athubAxios.get(`${ATHUB_CLOUD_SERVER}/api/sys/deptAll.sp?appId=WEB&token=${localStorage.getItem('token')}`)
                .then(res => {
                    resolve(res.data);
                }, error => {
                    reject(error);
                });
        });
    },

    // 作业内容的数据中心（部门）
    getDept4JobPlan() {
        return new Promise(function (resolve, reject) {
            Promise.all([
                AthubCloudApi.fetchSysDeptAllList(),
                AthubCloudApi.fetchAllSysroomList(),
            ]).then(res => {
                let departments = res[0], rooms = res[1];
                let departmentsMap = _.keyBy(departments, 'deptid');
                let jobPlanDepartments = _.uniq(rooms.filter(room => room.status === 'RUNNING' || room.status === 'CONSTRUCTING' || room.status === 'VIRTUAL')
                    .map(room => room.dept_id)).map(departmentId => departmentsMap[departmentId]).filter(department => department != null)
                    .map(department => {
                        department.id = parseInt(department.deptid);
                        department.name = department.deptname;
                        return department;
                    });
                resolve(jobPlanDepartments);
            }, error => {
                reject(error);
            });
        });
    },

    //获取全量职级信息
    fetchDeptpostList() {
        return new Promise((resolve, reject) => {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/api/sys/fetchDeptpostList.sp`, {
                appId: 'WEB',
                token: localStorage.getItem('token'),
            }).then((responseBody) => {
                if (responseBody.status == 200) {
                    resolve(responseBody.data.data);
                } else {
                    reject('获取职级信息失败');
                }
            }, (error) => {
                reject(error);
            });
        });
    },

    getRealName(username) {
        return new Promise(function (resolve, reject) {
            athubAxios.get(addParamsToUrl(`${ATHUB_CLOUD_SERVER}/sysuser/getRealname.sp`, {
                appId: 'WEB',
                token: localStorage.getItem('token'),
                username: username,
            })).then((res) => {
                resolve(res.data.realname);
            }, (error) => {
                reject(error);
            });
        });
    },

    /**
     * 大屏-pue趋势
     */
    featurePueTrend(){
        return athubAxios.get(`${ATHUB_CLOUD_SERVER}/api/sys/pueTrend.sp`);
    },

    /**
     * 大屏-指定数据中心pue趋势
     */
    featurePueTrendByRoomid(roomid){
        return athubAxios.get(`${ATHUB_CLOUD_SERVER}/api/sys/pueTrendByRoomId.sp?roomId=${roomid}`);
    },

    /**
     * 大屏-节能减排
     */
    featureSaveEnergy() {
        return athubAxios.get(`${ATHUB_CLOUD_SERVER}/api/sys/saveEnergy.sp`);
    },

    /**
     * 大屏-指定日期、时间点的抄表值
     */
    featureCbInfoByDateTime(params) {
        let url = `${ATHUB_CLOUD_SERVER}/api/sys/getCbInfoByDateTime.sp`;
        return new Promise((resolve, reject) => {
            athubAxios.postByForm(url, params).then(responseBody => {
                if (responseBody.status == 200 && responseBody.data.code == 'OK') {
                    resolve(responseBody.data.data);
                } else {
                    reject(responseBody.data.message);
                }
            });
        });
    },

    //获取首页能耗数据
    fetchDailyAmountInfo(roomIds) {
        return new Promise(function (resolve, reject) {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/api/sys/dailyAmountInfo.sp`, {
                'appId': 'WEB',
                'token': localStorage.getItem('token'),
                'roomId': roomIds
            }).then((res) => {
                resolve(res.data);
            }, (error) => {
                reject(error);
            });
        });
    },

    //获取当前员工的工作流任务
    fetchCurrentTask() {
        return new Promise(function (resolve, reject) {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/workflow/fetchCurrentTask.sp`, {
                'appId': 'WEB',
                'token': localStorage.getItem('token'),
            }).then((res) => {
                if (res.data.code == 'OK') {
                    resolve(res.data.data);
                } else {
                    reject('获取当前任务失败');
                }
            }, (error) => {
                reject('获取当前任务失败');
            });
        });
    },

    //统计星级占比总人数
    fetchStaffstarcount(sysRoomIds) {
        return new Promise(function (resolve, reject) {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/api/sys/staffstarcount.sp`, {
                'appId': 'WEB',
                'token': localStorage.getItem('token'),
                'roomIds': sysRoomIds,
            }).then((res) => {
                if (res.data.code == 200) {
                    resolve(res.data.data);
                } else {
                    reject('员工星级等级获取失败');
                }
            }, (error) => {
                reject('员工星级等级获取失败');
            });
        });
    },

    //根据机房获取所属部门
    getDeptsByRoomIds(sysRoomIds) {
        return new Promise(function (resolve, reject) {
            athubAxios.postByMultipartForm(`${ATHUB_CLOUD_SERVER}/sys/room/getDeptsByRooms.sp`, {
                'appId': 'WEB',
                'token': localStorage.getItem('token'),
                'roomIds': sysRoomIds,
            }).then((res) => {
                if (res.data.code == 200) {
                    resolve(res.data.deptIds);
                } else {
                    reject('获取部门信息失败');
                }
            }, (error) => {
                reject('获取部门信息失败');
            });
        });
    },

};

export default AthubCloudApi;
